
let select=(ele)=>{
   let item= document.querySelectorAll(ele);

   let sle=(item.length > 1) ? item : item[0];
   return sle;
}

let swatch=select(".swatch-item");
let prodOption=select('product-option-picker');
let varArr=[];
prodOption.forEach((item)=>{
  varArr.push(item.getAttribute('option'));
})

getProductData=()=>{
    let prodJson=select(".product-custom-json").innerHTML;
    let varData=JSON.parse(prodJson);

    return varData;
}

getMetafieldsById=(id)=>{
    let varData=getProductData();
    console.log(varData);
    let obj=varData.variants;
    for(item of obj){
        if(item.id==id){
            return item.size;
        }
    }
}

gettitleById=(id)=>{
    let varData=getProductData();
    let obj=varData.variants;
    for(item of obj){
        if(item.id==id){
            return item.title;
        }
    }
}

getVarIdByTitle=(title)=>{
    let varData=getProductData();
    let obj=varData.variants;
    for(item of obj){
        if(item.title==title){
            return item.id;
        }
    }
}

swatch.forEach(element => {
    element.addEventListener("mouseenter",()=>{
      let targetEle=element.previousElementSibling;
      let par=element.parentElement.parentElement.closest(":not(div)").getAttribute("option");
        
        if(targetEle.name=='Size' || targetEle.name=='size' ||  targetEle.name=='Kid Size'){
            let title=gettitleById(select("[name=id]")[0].value);
            let optValArr=title.split('/');
            let index=varArr.indexOf(par);
            let CurrentoptVal=targetEle.value

            optValArr[index]=CurrentoptVal;
            console.log(optValArr);
           let newVartitle= optValArr.join(" /");

           console.log(newVartitle);

           let varId=getVarIdByTitle(newVartitle);
           console.log(varId);
           let metafieldsSize=getMetafieldsById(varId);
           targetEle.previousElementSibling.innerText=metafieldsSize;
           console.log(metafieldsSize);
          if(targetEle.previousElementSibling.innerText=='Tooltip text' || targetEle.previousElementSibling.innerText=='undefined'){
            targetEle.previousElementSibling.style.display="none";
          }else{
            targetEle.previousElementSibling.style.display="block";
          }
        }else{
          let targetEle=element.previousElementSibling;
          targetEle.previousElementSibling.style.display="none";
          
        }
    })
});

// console.log(getMetafieldsById(43042433499302));
